// extracted by mini-css-extract-plugin
export default {"root":"KSgNa8oOTh5EfcWvpcYM"};